import React, { useState, useEffect } from "react";
import "./Admin.css";
import { supabase } from "./supabaseClient";

export default function Admin({ onLogout, session }) {
  const [links, setLinks] = useState([
    {
      id: 1,
      name: "Example Link",
      campaign: "Welcome Campaign",
      type: "Product",
      data: [{ key: "pid", value: "123" }, { key: "ref", value: "email" }],
    },
  ]);

  const [showModal, setShowModal] = useState(false);
  const emptyForm = {
    name: "",
    campaign: "",
    type: "Product",
    data: [{ key: "", value: "" }],
  };
  const [form, setForm] = useState(emptyForm);

  const fetchLinks = async () => {
    const { data, error } = await supabase
      .from("links")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) console.error(error);
    else setLinks(data);
  };

  useEffect(() => {

    console.log("i am here");
    fetchLinks();
  }, []);


  function openModal() {
    setForm(emptyForm);
    setShowModal(true);
  }
  function closeModal() {
    setShowModal(false);
  }

  function handleDataChange(index, field, value) {
    const newData = form.data.map((r, i) => (i === index ? { ...r, [field]: value } : r));
    setForm({ ...form, data: newData });
  }

  function addDataField() {
    setForm({ ...form, data: [...form.data, { key: "", value: "" }] });
  }

  function removeDataField(index) {
    if (form.data.length === 1) {
      // keep at least one row
      setForm({ ...form, data: [{ key: "", value: "" }] });
      return;
    }
    const newData = form.data.filter((_, i) => i !== index);
    setForm({ ...form, data: newData });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim()) {
      alert("Please provide a Name for the link.");
      return;
    }

    // 🔍 check if campaign with same name exists
    const { data: existing, error: fetchError } = await supabase
      .from("links") // replace with your table name
      .select("id")
      .eq("campaign_name", form.campaign.trim());

    if (fetchError) {
      console.error(fetchError);
      alert("Something went wrong while checking campaigns.");
      return;
    }

    if (existing && existing.length > 0) {
      alert("Campaign name already exists. Please choose another name.");
      return;
    }

    const newLink = {
      name: form.name.trim(),
      campaign_name: form.campaign.trim(),
      type: form.type,
      data: form.data.map(d => ({ key: d.key.trim(), value: d.value.trim() })),
    };

    try {
      const { data, error } = await supabase
        .from("links") // 👈 your table name in Supabase
        .insert([newLink]);

      if (error) {
        console.error("Error inserting link:", error);
        alert("Error saving link.");
        return;
      }

      fetchLinks();
      // Update UI after successful insert
      // setLinks(prev => [data[0], ...prev]); 
      setShowModal(false);
      setForm(emptyForm);

    } catch (err) {
      console.error("Unexpected error:", err);
      alert("Something went wrong while saving link.");
    }
  }


  //   const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const newLink = {
  //     name,
  //     campaign_name: campaignName,
  //     type,
  //     data: dataList.reduce((acc, { key, value }) => {
  //       if (key && value) acc[key] = value;
  //       return acc;
  //     }, {}),
  //   };

  //   const { data: insertedData, error } = await supabase
  //     .from("links")
  //     .insert([newLink])
  //     .select();

  //   if (error) {
  //     console.error("Insert error:", error);
  //   } else {
  //     console.log("Inserted:", insertedData);
  //     setLinks([...links, insertedData[0]]);
  //     setShowForm(false);
  //     resetForm();
  //   }
  // };


  // function handleSubmit(e) {
  //   e.preventDefault();
  //   if (!form.name.trim()) {
  //     alert("Please provide a Name for the link.");
  //     return;
  //   }

  //   const newLink = {
  //     id: Date.now(),
  //     name: form.name.trim(),
  //     campaign: form.campaign.trim(),
  //     type: form.type,
  //     data: form.data.map(d => ({ key: d.key.trim(), value: d.value.trim() })),
  //   };

  //   setLinks(prev => [newLink, ...prev]);
  //   setShowModal(false);
  //   setForm(emptyForm);
  // }

  return (
    <div className="admin-wrap">
      <aside className="sidebar">
        <div className="brand">⚡ Link Admin</div>
        <nav>
          <ul>
            <li className="active">Links</li>
            <li>Campaigns</li>
            <li>Settings</li>
          </ul>
        </nav>
        <div className="sidebar-footer">
          <div className="user-email">{session?.user?.email ?? "You"}</div>
          <button className="btn-ghost" onClick={onLogout}>Logout</button>
        </div>
      </aside>

      <main className="main">
        <header className="topbar">
          <h1>Links</h1>
          <div className="top-actions">
            <button className="btn-primary" onClick={openModal}>+ Create Link</button>
          </div>
        </header>

        <section className="card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Campaign</th>
                <th>Type</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {links.length === 0 ? (
                <tr>
                  <td colSpan="4" className="empty">No links yet. Click "Create Link" to add one.</td>
                </tr>
              ) : (
                links.map(link => (
                  <tr key={link.id}>
                    <td>{link.name}</td>
                    <td>{link.campaign_name}</td>
                    <td>{link.type}</td>
                    <td>
                      <div className="kv-wrap">
                        {link.data.map((d, i) => (
                          <span className="kv-pill" key={i}>
                            <strong className="kv-key">{d.key || "(key)"}</strong>
                            <span className="kv-sep">:</span>
                            <span className="kv-val">{d.value || "(value)"}</span>
                          </span>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </section>
      </main>

      {showModal && (
        <div className="modal-backdrop" onMouseDown={closeModal}>
          <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <h2>Create Link</h2>
              <button className="close-x" onClick={closeModal} aria-label="Close">✕</button>
            </div>

            <form onSubmit={handleSubmit} className="modal-form">
              <label>
                <div className="label">Name</div>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="Enter link name"
                  required
                />
              </label>

              <label>
                <div className="label">Campaign Name</div>
                <input
                  type="text"
                  value={form.campaign}
                  onChange={(e) => setForm({ ...form, campaign: e.target.value })}
                  placeholder="Campaign (optional)"
                />
              </label>

              <label>
                <div className="label">Type</div>
                <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                  <option>Product</option>
                  <option>Store</option>
                  <option>Search</option>
                </select>
              </label>

              <div className="label">Data (key / value)</div>
              <div className="data-list">
                {form.data.map((row, idx) => (
                  <div className="data-row" key={idx}>
                    <input
                      type="text"
                      className="input-key"
                      placeholder="Key"
                      value={row.key}
                      onChange={(e) => handleDataChange(idx, "key", e.target.value)}
                    />
                    <input
                      type="text"
                      className="input-value"
                      placeholder="Value"
                      value={row.value}
                      onChange={(e) => handleDataChange(idx, "value", e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn-danger small"
                      onClick={() => removeDataField(idx)}
                      title="Remove"
                    >
                      −
                    </button>
                  </div>
                ))}
                <div>
                  <button type="button" className="btn-outline" onClick={addDataField}>
                    + Add Field
                  </button>
                </div>
              </div>

              <div className="modal-actions">
                <button type="submit" className="btn-primary" disabled={!form.name.trim()}>
                  Save Link
                </button>
                <button type="button" className="btn-ghost" onClick={closeModal}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
